import { motion } from "framer-motion";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

const XIcon = () => (
    <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#D92D20]" aria-hidden>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white">
            <path d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    </span>
);

const CheckIcon = () => (
    <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0B7F47]" aria-hidden>
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white">
            <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </span>
);

const BEFORE_ITEMS = ["High service fee", "Slow customer response", "Switching between multiple apps for services"];
const AFTER_ITEMS = ["Low service fee", "Fast customer response", "AfriPay is a one-stop shop for international and local transactions"];

export default function CompareSection() {
    return (
        <motion.section
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
            className="max-w-7xl mx-auto px-4 md:px-5 mb-8 md:mb-10"
        >
            <motion.div variants={fadeUp} className="text-center mb-4 md:mb-5">
                <h2 className="font-display-fran font-semibold text-[22px] md:text-3xl leading-[1.1] tracking-[-0.02em] mb-2">
                    <span className="text-[#8F92A1]">The Old Way </span>
                    <span className="text-[#030319]">Vs </span>
                    <span className="text-[#0B7F47]">AfriPay Way</span>
                </h2>
                <p className="text-[#344054] text-[13px] md:text-sm max-w-xl mx-auto">
                    Stop losing money to fees and waiting for every transaction to go through.
                </p>
            </motion.div>

            <div className="grid md:grid-cols-2 rounded-2xl overflow-hidden border border-[#E2E8F0] shadow-sm">
                {/* Before */}
                <motion.div variants={slideInLeft} className="bg-[#F1F5F9] px-5 py-5 md:px-6 md:py-6 flex flex-col">
                    <h3 className="text-base md:text-lg font-semibold text-[#475467] mb-3">Before AfriPay</h3>
                    <ul className="space-y-2 flex-1">
                        {BEFORE_ITEMS.map((item) => (
                            <li key={item} className="flex items-start gap-2.5">
                                <XIcon />
                                <span className="text-[#030319] text-sm md:text-[15px] font-medium leading-snug pt-0.5">{item}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-3 flex justify-center md:justify-end">
                        <img
                            src="/images/sadUser.png"
                            alt="Stressed person working at a laptop"
                            className="max-h-[120px] md:max-h-[140px] w-auto object-contain object-bottom"
                        />
                    </div>
                </motion.div>

                {/* After */}
                <motion.div variants={slideInRight} className="bg-[#DEF2E9] px-5 py-5 md:px-6 md:py-6 flex flex-col border-t md:border-t-0 md:border-l border-[#E2E8F0]">
                    <h3 className="text-base md:text-lg font-semibold text-[#0B7F47] mb-3">With AfriPay</h3>
                    <ul className="space-y-2 flex-1">
                        {AFTER_ITEMS.map((item) => (
                            <li key={item} className="flex items-start gap-2.5">
                                <CheckIcon />
                                <span className="text-[#030319] text-sm md:text-[15px] font-medium leading-snug pt-0.5">{item}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-3 flex justify-center md:justify-end">
                        <img
                            src="/images/happy-student.png"
                            alt="Happy people celebrating"
                            className="max-h-[120px] md:max-h-[140px] w-auto object-contain max-w-[55%] md:max-w-[48%]"
                        />
                    </div>
                </motion.div>
            </div>
        </motion.section>
    );
}